"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let MeterDataExchange = class MeterDataExchange extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    file;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    resultText;
    downloadMeterDataExchangeFileURL;
    async $$load_downloadMeterDataExchangeFileURL() {
        return this.$fn.urlFor('meters/get_sensor_data_exchange', { format: 'xlsx' });
    }
    ux;
    b_7315092382398562_modalBindings;
    b_3086171180629160_validation;
    dataMembers = ['file', 'formId', 'formName', 'resultText', 'downloadMeterDataExchangeFileURL', 'ux', 'b_7315092382398562_modalBindings', 'b_3086171180629160_validation'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                file: null,
                formId: null,
                formName: "meterDataExhange",
                resultText: null,
                downloadMeterDataExchangeFileURL: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
                b_3086171180629160_validation: ["ext:xlsx",
                    "required",
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.gettext("Meter Data Exchange"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3432_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_648747096704084_register_3438_getActionArgs($event) {
        return {
            name: "resultLength",
            value: $event.data.response.data ? $event.data.response.data.length : 0,
        };
    }
    async act_648747096704084_setData_3440_getActionArgs($event) {
        return {
            path: "resultText",
            value: this.$fn.ngettext("One event has been imported.", "${n} events have been imported.", this.resultLength),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_648747096704084_success_3439_getWhen($event) {
        return $event.data.resultLength > 0;
    }
    async act_648747096704084_setData_3442_getActionArgs($event) {
        return {
            path: "resultText",
            value: this.$fn.gettext("No events have been imported."),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_648747096704084_success_3441_getWhen($event) {
        return !$event.data.resultLength;
    }
    async act_648747096704084_request_3436_getActionArgs($event) {
        return {
            operation: "meters/upload_sensor_data_exchange",
            data: { file: this.file },
        };
    }
    async evh_648747096704084_submit(event, scope) {
        return await this.actions.evh_648747096704084_submit.executeFromDOM(this, event, scope);
    }
    async act_1419464017721962_closeModal_3444_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
            },
        };
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3432 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3432_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3431 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3432,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3431],
        });
        const act_2248226175642056_closeComponent_3434 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_3433 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_3434,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3433],
        });
        const act_648747096704084_register_3438 = new core_1.actions.RegisterAction({
            actionArgs: this.act_648747096704084_register_3438_getActionArgs,
            events: [],
        });
        const evh_648747096704084_success_3437 = new core_1.actions.EventHandlerImpl({
            action: act_648747096704084_register_3438,
            event: "success",
            displayName: "register",
        });
        const act_648747096704084_setData_3440 = new core_1.actions.SetDataAction({
            actionArgs: this.act_648747096704084_setData_3440_getActionArgs,
            events: [],
        });
        const evh_648747096704084_success_3439 = new core_1.actions.EventHandlerImpl({
            action: act_648747096704084_setData_3440,
            event: "success",
            when: this.evh_648747096704084_success_3439_getWhen,
            displayName: "setData",
        });
        const act_648747096704084_setData_3442 = new core_1.actions.SetDataAction({
            actionArgs: this.act_648747096704084_setData_3442_getActionArgs,
            events: [],
        });
        const evh_648747096704084_success_3441 = new core_1.actions.EventHandlerImpl({
            action: act_648747096704084_setData_3442,
            event: "success",
            when: this.evh_648747096704084_success_3441_getWhen,
            displayName: "setData",
        });
        const act_648747096704084_request_3436 = new core_1.actions.RequestAction({
            actionArgs: this.act_648747096704084_request_3436_getActionArgs,
            displayName: "submit",
            events: [evh_648747096704084_success_3437, evh_648747096704084_success_3439, evh_648747096704084_success_3441],
        });
        const evh_648747096704084_submit_3435 = new core_1.actions.EventHandlerImpl({
            action: act_648747096704084_request_3436,
            event: "submit",
            displayName: "submit",
        });
        const evh_648747096704084_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_648747096704084_submit_3435],
        });
        const act_1419464017721962_closeModal_3444 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1419464017721962_closeModal_3444_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_3443 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeModal_3444,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_3443],
        });
        return {
            act_7315092382398562_closeModal_3432,
            evh_7315092382398562_close_3431,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_3434,
            evh_2248226175642056_close_3433,
            evh_2248226175642056_close,
            act_648747096704084_register_3438,
            evh_648747096704084_success_3437,
            act_648747096704084_setData_3440,
            evh_648747096704084_success_3439,
            act_648747096704084_setData_3442,
            evh_648747096704084_success_3441,
            act_648747096704084_request_3436,
            evh_648747096704084_submit_3435,
            evh_648747096704084_submit,
            act_1419464017721962_closeModal_3444,
            evh_1419464017721962_clickPreventStop_3443,
            evh_1419464017721962_clickPreventStop,
            submit: act_648747096704084_request_3436,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], MeterDataExchange.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MeterDataExchange.prototype, "onSize", null);
MeterDataExchange = __decorate([
    (0, vue_property_decorator_1.Component)()
], MeterDataExchange);
exports.default = MeterDataExchange;
vue_property_decorator_1.Vue.component("MeterDataExchange", MeterDataExchange);
